module.exports = __webpack_public_path__ + "img/news28-0.8c1b6a6c.png";